export const CLIENT_IDS = {
  OVERVIEW: 'overview',
  GLOBAL_V1: 'global_v1'
}

export const DEFAULT_LAYOUT_ID = '00000000';
export const DEFAULT_TEMPLATE_ID = '00000000';
